export const FETCH_MANAGER_DASHBOARD = "FETCH_MANAGER_DASHBOARD";
export const FETCH_ADMIN_DASHBOARD = "FETCH_ADMIN_DASHBOARD";
